import React, {useEffect } from 'react';
import Menu from "../include/menu";
import Footer from "../include/footer";
import AOS from "aos";
import "aos/dist/aos.css";
import IndexWrapper from "./index-wrapper.js";
import TransactionStatus from "../txnStatus";

const IndexSections = () => {
  useEffect(() => {
    AOS.init({
      duration: 1000, 
      once: true,  
    });
  }, []);
  return (
  <>
  <Menu />
  <IndexWrapper />
  <TransactionStatus />
  <Footer />
  </>
  );
};

export default IndexSections;